var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('SplitEditor',{attrs:{"mode":"sql","theme":"solarized_light","splits":1,"orientation":"beside","width":"100%","name":"editor","value":[_vm.value],"enableBasicAutocompletion":true,"tabSize":4,"onChange":_vm.onChange,"editorProps":{
    $blockScrolling: true,
  }}})}
var staticRenderFns = []

export { render, staticRenderFns }